import React, { useState, useEffect, useContext } from "react";
import { Chart } from "react-google-charts";

import { bolas_detalhes_renovados } from "../../services/api";

import './detalhamento_bolsa.css';

const Detalhamento_bolsa_renovados = (props) => {

    const [data2, setData2] = useState([]);

    const perfil = JSON.parse(localStorage.getItem("perfil"));

    const meu_perfil = perfil[0].perfil;

    const unidades = ['', 'Bento Ribeiro', 'Madureira', 'Santa Cruz', 'Cascadura', 'Taquara', 'Nilopolis', 'Nova Iguaçu', '', 'Seropédica', 'Barra da Tijuca', 'Campo Grande', 'Centro de Excelência', 'Mangueira', 'Maricá', 'Ilha do Governador', 'Freguesia', 'Recreio dos Bandeirantes']

    let data_inicio = props.di;
    let data_fim = props.df;
    let cod_unidade = props.un;

    const fetchData = async () => {
        try {
            const response = await bolas_detalhes_renovados(data_inicio, data_fim, cod_unidade);
            console.log("response detalhamento", response)
            setData2(response);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        console.log("B")
        fetchData();
    }, [data_inicio, data_fim]);

    const convertSegmento = (seg) => {
        switch (seg) {
            case '0-1':
                return 'Mat 1';
            case '0-2':
                return 'Mat 2';
            case '0-3':
                return 'Pré 1';
            case '0-4':
                return 'Pré 2';
            case '1-1':
                return '1º Fund I';
            case '1-2':
                return '2º Fund I';
            case '1-3':
                return '3º Fund I';
            case '1-4':
                return '4º Fund I';
            case '1-5':
                return '5º Fund I';
            case '1-6':
                return '6º Fund II';
            case '1-7':
                return '7º Fund II';
            case '1-8':
                return '8º Fund II';
            case '1-9':
                return '9º Fund II';
            case '2-1':
                return '1ª Médio';
            case '2-2':
                return '2ª Médio';
            case '2-3':
                return '3ª Médio';
            default:
                return seg;
        }
    };

    let chartDataDet = [];

    function formatarMoeda(valor) {
        // Use o Intl.NumberFormat para formatar o valor para o formato monetário
        const formatoMoeda = new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL',
        });

        return formatoMoeda.format(valor);
    }

    let total = []
    for (var i = 0; i < 21; i++) {
        total.push(0);
    }

    if (typeof data2 !== 'undefined') {
        chartDataDet = data2.map((item, index) => {
            const row = [convertSegmento(item.seg)];
            total[0] = "Total"
            row.push(item.bolsa_0 || 0);
            total[1] = total[1] + parseInt(item.bolsa_0)
            row.push(item.bolsa_5 || 0);
            total[2] = total[2] + parseInt(item.bolsa_5)
            row.push(item.bolsa_10 || 0);
            total[3] = total[3] + parseInt(item.bolsa_10)
            row.push(item.bolsa_15 || 0);
            total[4] = total[4] + parseInt(item.bolsa_15)
            row.push(item.bolsa_20 || 0);
            total[5] = total[5] + parseInt(item.bolsa_20)
            row.push(item.bolsa_25 || 0);
            total[6] = total[6] + parseInt(item.bolsa_25)
            row.push(item.bolsa_30 || 0);
            total[7] = total[7] + parseInt(item.bolsa_30)
            row.push(item.bolsa_35 || 0);
            total[8] = total[8] + parseInt(item.bolsa_35)
            row.push(item.bolsa_40 || 0);
            total[9] = total[9] + parseInt(item.bolsa_40)
            row.push(item.bolsa_45 || 0);
            total[10] = total[10] + parseInt(item.bolsa_45)
            row.push(item.bolsa_50 || 0);
            total[11] = total[11] + parseInt(item.bolsa_50)
            row.push(item.bolsa_55 || 0);
            total[12] = total[12] + parseInt(item.bolsa_55)
            row.push(item.bolsa_100 || 0);
            total[13] = total[13] + parseInt(item.bolsa_100)
            row.push(item.total_matriculas || 0);
            total[14] = total[14] + parseFloat(item.total_matriculas)
            row.push(parseFloat(item.desconto_medio));

            row.push(formatarMoeda(item.anuidade_esperada_sem_desconto || 0));
            total[16] = total[16] + parseFloat(item.anuidade_esperada_sem_desconto)
            let des = parseFloat(item.anuidade_esperada_sem_desconto || 0) - parseFloat(item.anuidade_ajustada_esperada || 0)
            //row.push(formatarMoeda((des * (-1)) || 0));
            row.push((des * (-1)));
            total[17] = total[17] + des
            //row.push(`<span className="bold-red">${formatarMoeda(des || 0)}</span>`);
            row.push(formatarMoeda(item.anuidade_ajustada_esperada || 0));
            total[18] = total[18] + parseFloat(item.anuidade_ajustada_esperada)
            row.push(formatarMoeda(item.anuidade_ajustada_media || 0));
            total[19] = total[19] + (parseFloat(item.anuidade_ajustada_media) * parseFloat(item.total_matriculas));
            row.push(formatarMoeda(item.mensalidade_ajustada_media || 0));
            total[20] = total[20] + (parseFloat(item.mensalidade_ajustada_media) * parseFloat(item.total_matriculas));
            return row;
        });


    };

    // desconto médio = (total de desconto * 100 ) total sem desconto 
    total[15] = ((total[17] * 100) / total[16]);


    total[16] = formatarMoeda(total[16]);
    total[17] = total[17] * (-1);
    total[18] = formatarMoeda(total[18]);
    total[19] = formatarMoeda(total[19] / total[14]);
    total[20] = formatarMoeda(total[20] / total[14]);

    chartDataDet.push(total);

    console.log("Total", total);

    const options = {
        allowHtml: true,

    };
    let formatters = [
        {
            type: "NumberFormat",
            column: 17,
            options: {
                prefix: "R$",
                negativeColor: "red",
                negativeParens: true,
            },
        },
        {
            type: "NumberFormat",
            column: 15,
            options: {
                suffix: "%",
                negativeColor: "red",
                negativeParens: true,
            },
        },
        {
            type: "ColorFormat",
            column: 15,
            ranges: [
                [0, 25, "white", "green"],
                [25, 40, "white", "orange"],
                [40, 55, "white", "red"],
                [55, 100, "white", "darkred"],
            ],
        },

    ];

    chartDataDet.unshift(['Segmento', '0%', '5%', '10%', '15%', '20%', '25%', '30%', '35%', '40%', '45%', '50%', '51% ~ 99%', '100%', 'Alunos', 'Desconto Médio', 'Anuidade SEM desconto', 'Desconto (R$)', 'Anuidade COM desconto', 'Anuidade Média Com Desconto', 'Mensalidade Média']);

    if (meu_perfil.startsWith("SECRETARIA")) {
        var colunasARemover = 5;

        // Remova as últimas colunas
        for (let i = 0; i < chartDataDet.length; i++) {
            chartDataDet[i] = chartDataDet[i].slice(0, -colunasARemover);
        }

        formatters = [
            {
                type: "NumberFormat",
                column: 15,
                options: {
                    suffix: "%",
                    negativeColor: "red",
                    negativeParens: true,
                },
            },
            {
                type: "ColorFormat",
                column: 15,
                ranges: [
                    [0, 25, "white", "green"],
                    [25, 40, "white", "orange"],
                    [40, 55, "white", "red"],
                    [55, 100, "white", "darkred"],
                ],
            },
        ];

    }

    return (
        <div className="bolsas">
            <Chart
                chartType="Table"
                version="current"
                width="100%"
                data={chartDataDet}
                options={options}
                formatters={formatters}
            />
        </div>
    );
};
export default Detalhamento_bolsa_renovados;